import {ItemCodeTypeMap, StringTypeMap, BooleanTypeMap,
  ISODateTypeMap, NullableISODateTypeMap
} from "./generaltypemaps"
import {ApiObjectFields, ItemCode, EOFields} from "./types"
import {ISODate} from "../date"
import {ApiObject} from "./api"

export const ItemFields = {
  code: ItemCodeTypeMap,
  description: StringTypeMap,
  isStockItem: BooleanTypeMap,
  isSalesItem: BooleanTypeMap,
  isPurchaseItem: BooleanTypeMap,
  startDate: ISODateTypeMap,
  endDate: NullableISODateTypeMap,
}


export class Item extends ApiObject implements ApiObjectFields<typeof ItemFields> {
  readonly code: ItemCode
  readonly description: string
  readonly isStockItem: boolean
  readonly isSalesItem: boolean
  readonly isPurchaseItem: boolean
  readonly startDate: ISODate
  readonly endDate: ISODate | null

  constructor(props: EOFields<typeof Item>) {
    super({})
    this.code = Item.FIELDS.code.fromEO(props.Code)
    this.description = Item.FIELDS.description.fromEO(props.Description)
    this.isStockItem = Item.FIELDS.isStockItem.fromEO(props.IsStockItem)
    this.isSalesItem = Item.FIELDS.isSalesItem.fromEO(props.IsSalesItem)
    this.isPurchaseItem = Item.FIELDS.isPurchaseItem.fromEO(props.IsPurchaseItem)
    this.startDate = Item.FIELDS.startDate.fromEO(props.StartDate)
    this.endDate = Item.FIELDS.endDate.fromEO(props.EndDate)
  }

  static get FIELDS(): typeof ItemFields {
    return ItemFields
  }

  static get URL(): string {
    return "logistics/Items"
  }

}

